import { Logo } from './Logo'
import { Award, ShieldCheck } from 'lucide-react'
const Footer = ({ onOpenLegal }) => {
  return (
    <footer className="bg-[#011614] border-t border-[#00FF9D]/15 pt-16 pb-12 text-[#CBD5E1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Branding and Description */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 items-center">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-4">
              <Logo size="md" glow={true} />
              <span className="px-2.5 py-0.5 rounded-full text-xs font-mono font-medium bg-[#05332E] text-[#00FF9D] border border-[#00FF9D]/20">
                Marketing Intelligence
              </span>
            </div>
            <p className="text-sm text-[#CBD5E1] max-w-md leading-relaxed">
              La plataforma de IA especializada en Agentes Autónomos para
              agencias de marketing con +10 clientes. Escala tu margen operativo
              al 85%+ con calidad Ultra-Premium.
            </p>
          </div>

          <div className="md:col-span-6 flex flex-wrap items-center md:justify-end gap-3 text-xs font-mono">
            <a
              href="#agentes"
              className="px-3 py-1.5 rounded-lg bg-[#05332E]/60 hover:bg-[#05332E] text-[#CBD5E1] hover:text-[#00FF9D] transition-colors border border-white/5"
            >
              Agentes de IA
            </a>
            <a
              href="#oficina-virtual"
              className="px-3 py-1.5 rounded-lg bg-[#05332E]/60 hover:bg-[#05332E] text-[#CBD5E1] hover:text-[#00FF9D] transition-colors border border-white/5"
            >
              Oficina Virtual
            </a>
            <a
              href="#precios"
              className="px-3 py-1.5 rounded-lg bg-[#05332E]/60 hover:bg-[#05332E] text-[#CBD5E1] hover:text-[#00FF9D] transition-colors border border-white/5"
            >
              Precios
            </a>
            <a
              href="#lanzadera"
              className="px-3 py-1.5 rounded-lg bg-[#05332E]/60 hover:bg-[#05332E] text-[#CBD5E1] hover:text-[#00FF9D] transition-colors border border-white/5"
            >
              Lanzadera
            </a>
          </div>
        </div>

        {/* MÓDULO CENTRAL DESTACADO (From user prompt requirements) */}
        <div className="my-10 p-6 sm:p-8 rounded-2xl bg-[#031E1B] border border-[#00FF9D]/25 shadow-lg relative overflow-hidden">
          <div className="flex flex-col sm:flex-row items-center gap-5 text-center sm:text-left">
            <div className="w-14 h-14 rounded-xl bg-[#05332E] border border-[#00FF9D]/40 flex items-center justify-center text-[#00FF9D] flex-shrink-0 shadow-inner">
              <Award className="w-7 h-7" />
            </div>
            <div className="flex-1">
              <div className="text-xs font-mono text-[#00FF9D] uppercase tracking-wider mb-1 font-bold flex items-center justify-center sm:justify-start gap-2">
                <ShieldCheck className="w-3.5 h-3.5" />
                Acreditación Institucional & Garantía
              </div>
              <p className="text-sm sm:text-base text-white leading-relaxed font-medium">
                Hutrit forma parte de{' '}
                <strong className="text-[#00FF9D]">Lanzadera</strong>, la
                aceleradora de startups referente en España, impulsada por{' '}
                <strong className="text-white">Juan Roig</strong> (fundador de
                Mercadona). Ubicados en el polo de innovación{' '}
                <strong className="text-white">Marina de Empresas</strong>{' '}
                (Valencia).
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Legal Navigation & Copyright */}
        <div className="pt-8 border-t border-[#05332E] flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-mono">
          {/* Copyright */}
          <div className="text-[#CBD5E1]/60">
            © Hutrit AI - All rights reserved.
          </div>

          {/* Enlaces de navegación legal */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-[#CBD5E1]/80">
            <button
              onClick={() => onOpenLegal('legal')}
              className="hover:text-[#00FF9D] transition-colors cursor-pointer"
            >
              Aviso Legal
            </button>
            <button
              onClick={() => onOpenLegal('privacy')}
              className="hover:text-[#00FF9D] transition-colors cursor-pointer"
            >
              Política de Privacidad
            </button>
            <button
              onClick={() => onOpenLegal('terms')}
              className="hover:text-[#00FF9D] transition-colors cursor-pointer"
            >
              Términos de Servicio
            </button>
            <button
              onClick={() => onOpenLegal('contact')}
              className="hover:text-[#00FF9D] transition-colors cursor-pointer"
            >
              Contacto
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}
export { Footer }
